import { useEffect } from "react";
import { speakAssist } from "../components/Utility";
import { Role } from "../enums/enums";
import { toast } from "react-toastify";

const SpeakOrderSocket = ({ socket, userRole }) => {
    useEffect(() => {
        if (!userRole?.scopeId || !socket) return;

        const handleNewOrder = (data) => {
            // Strict check for Employee role
            if (userRole.role === Role.Employee) {
                const orderNo = data?.order?.orderNo;
                if (orderNo) {
                    const message = `New Order Placed: number ${orderNo}`;
                    speakAssist(message);
                    console.log(message);
                    toast.success(`New Order Placed: ${orderNo}`);
                }
            }
        };

        // Listen for new orders
        socket.on("newOrder", handleNewOrder);

        // Cleanup listener when scopeId/role changes or unmount
        return () => {
            socket.off("newOrder", handleNewOrder);
        };
    }, [userRole?.scopeId, userRole?.role, socket]);

    return null; // this component doesn't render UI
}

export default SpeakOrderSocket;